
import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <div className="pt-[calc(var(--header-h)+1rem)] pb-6 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <nav className="flex items-center space-x-2 text-sm">
          {items.map((item, index) => (
            <div key={index} className="flex items-center">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-gray-400 mx-2"></i>
              )}
              {item.href ? (
                <Link
                  to={item.href}
                  className="text-gray-600 hover:text-[#a38e65] transition-colors duration-200 cursor-pointer font-medium"
                >
                  {index === 0 && (
                    <i className="ri-home-line mr-1"></i>
                  )}
                  {item.label}
                </Link>
              ) : (
                <span className="text-[#a38e65] font-medium">
                  {item.label}
                </span>
              )}
            </div>
          ))}
        </nav>
      </div>
    </div>
  );
}
